import { render } from "./SidebarNav.vue?vue&type=template&id=036131d4&scoped=true"
import script from "./SidebarNav.vue?vue&type=script&lang=js"
export * from "./SidebarNav.vue?vue&type=script&lang=js"

import "./SidebarNav.vue?vue&type=style&index=0&id=036131d4&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src587305002/src/goku/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036131d4"]])

export default __exports__